import { Injectable } from '@angular/core';
import { RestaurantService } from './restaurant.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiService } from './api.service';

/**
 * `providedIn: 'root'` em vez de entrada no `CoreModule.providers`: o singleton é o mesmo, mas
 * o bundler passa a colocar este serviço no chunk de quem o INJETA. Listado no CoreModule, ele
 * viajava no `main.js` do boot — e esta tela só aparece depois de vários gestos.
 */
@Injectable({ providedIn: 'root' })
export class MotoboyTrackingService {
    private baseURL:string = 'https://ig7uqqbhe5r7wlggsmmrwl2rxe0zzqtf.lambda-url.us-east-1.on.aws'

    constructor(
        private restaurantService: RestaurantService,
        private apiService: ApiService,
        private httpClient: HttpClient
    ) {}

    getOrderCoordinates(orderUUID: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const restaurantID = this.restaurantService.restaurant.info.id;

            return this.httpClient
                .get(
                    `${this.baseURL}/get-by-order?restaurant-id=${restaurantID}&order-uuid=${orderUUID}`
                )
                .subscribe(
                    (result) => {
                        resolve(result);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    }
}
